import api from './api.js';

class CategoryService {
  async getProductsByCategory(categoryName) {
    try {
      // Récupérer tous les produits puis filtrer côté client
      const response = await api.get('/products/');
      const allProducts = response.data;
      
      // Filtrer les produits de la catégorie spécifiée
      const filtered = allProducts.filter(product => 
        product.category_name === categoryName
      );
      
      return filtered;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits par catégorie:', error);
      return [];
    }
  }

  async getSimilarProducts(productId, categoryName, limit = 8) {
    try {
      // Récupérer tous les produits et les avis
      const [productsResponse, reviewsResponse] = await Promise.all([
        api.get('/products/'),
        api.get('/reviews/')
      ]);
      
      const allProducts = productsResponse.data;
      const allReviews = reviewsResponse.data;
      
      // Calculer les notes moyennes pour chaque produit
      const productsWithRatings = allProducts.map(product => {
        const productReviews = allReviews.filter(review => 
          review.model === product.name || review.product_id === product.id
        );
        
        const averageRating = productReviews.length > 0
          ? productReviews.reduce((sum, review) => sum + review.rating, 0) / productReviews.length
          : 0;
        
        return {
          ...product,
          rating: averageRating,
          review_count: productReviews.length
        };
      });
      
      // Filtrer les produits de la même catégorie (sauf le produit actuel)
      const filtered = productsWithRatings.filter(product => 
        product.category_name === categoryName && 
        product.id !== productId
      ).slice(0, limit);
      
      return filtered;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits similaires:', error);
      return [];
    }
  }

  async getAllCategories() {
    try {
      const response = await api.get('/categories/');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories:', error);
      return [];
    }
  }
}

const categoryService = new CategoryService();
export default categoryService;
